import { trackMetric } from 'modules/analytics'
import { useEffect, useRef } from 'react'
import { useDidBrowserTabChange } from '@sketch/utils'

type UsePrototypeImagePreloadDurationProps = {
  imagePreloadStatus: 'idle' | 'loading' | 'completed' | 'error'
  imageCount: number
}

export function usePrototypeImagePreloadDurationMetric(
  props: UsePrototypeImagePreloadDurationProps
) {
  const { imageCount, imagePreloadStatus } = props
  const prevImagePreloadStatus = useRef(imagePreloadStatus)
  const startTime = useRef(0)
  const didBrowserTabChangeRef = useDidBrowserTabChange()

  useEffect(() => {
    if (
      prevImagePreloadStatus.current === 'idle' &&
      imagePreloadStatus === 'loading'
    ) {
      startTime.current = Date.now()
      prevImagePreloadStatus.current = imagePreloadStatus
    }
  }, [imagePreloadStatus])

  useEffect(() => {
    if (
      prevImagePreloadStatus.current === 'loading' &&
      imagePreloadStatus === 'completed'
    ) {
      prevImagePreloadStatus.current = imagePreloadStatus
      if (didBrowserTabChangeRef.current) return
      trackMetric({
        id: 'webapp_prototype_view_image_preload_duration_milliseconds',
        value: Date.now() - startTime.current,
        labels: {
          imagesCount: String(imageCount),
        },
      })
    }
  }, [imagePreloadStatus, imageCount, didBrowserTabChangeRef])
}
